<label class="esf-form-item__label">{{label}}<app-optional *ngIf="optional"></app-optional></label>
<div class="esf-form-item__field-wrapper" controlErrorContainer>
  <input class="esf-form-item__field" [type]="passwordType" autocomplete="new-password" [formControl]="formControl" [id]="id" (focus)="showOnFocus ? setPassword(true) : null">
  <span class="esf-form-item__icon esf-password__icon" (click)="togglePassword()">
    <svg class="esf-icon" width="16" height="16" [ngSwitch]="passwordType">
      <use *ngSwitchCase="'password'" xlink:href="#esf-icon-show"></use>
      <use *ngSwitchCase="'text'" xlink:href="#esf-icon-hide"></use>
    </svg>
  </span>
</div>
